import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import es from './locales/es.json';
import nl from './locales/nl.json'; 
import fr from './locales/fr.json';
import pt from './locales/pt-pt.json';
import el from './locales/el.json';
import de from './locales/de.json';
import it from './locales/it.json';
import ar from './locales/ar.json';




i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: "ar", // default language changed to Arabic
    fallbackLng: "en",
    supportedLngs: ["en", "es", "it", "de", "fr", "el", "ar"], 
    returnObjects: true,
    interpolation: {
      escapeValue: false,
      defaultVariables: { brandName: "Toros Trade" }
    },
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag", "path", "subdomain"],
      caches: ["localStorage", "cookie"], 
    },
    resources: {
      en: { translation: en },
      es: { translation: es },
      it: { translation: it },
      de: { translation: de },
      fr: { translation: fr },
      el: { translation: el },
      ar: { translation: ar },           
    }
  });

export default i18n;
